import { RouteComponentProps } from "react-router-dom";
import { RequirementsDetailsRoute } from "./RequirementsDetailsRoute";
import { WSPage } from "@wingspanhq/fe-component-library";
import { queriesPayers } from "@query";
import { selectorPayerResponseFromV3 } from "@selectors/selectorPayerResponseFromV3";
import { WSQueries } from "../../../../query/WSQuery";
import { useQueryRequirement } from "../../../../query/requirements/queries/useQueryRequirement";

export const RouteRequirementDetails: React.FC<
  RouteComponentProps<{
    payerId: string;
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId, payerId }
  }
}) => {
  const queryPayer = queriesPayers.getPayer.useQuery(
    { payerId },
    { retry: false }
  );
  const queryRequirement = useQueryRequirement(requirementId);

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryPayer,
          queryRequirement
        }}
      >
        {({ queryPayerData, queryRequirementData }) => {
          return (
            <RequirementsDetailsRoute
              payer={selectorPayerResponseFromV3(queryPayerData)}
              requirement={queryRequirementData}
            />
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
